"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentPaperPage_1 = require("./ComponentPaperPage");
exports.ComponentPaperPage = ComponentPaperPage_1.ComponentPaperPage;



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentPaperPage/index.ts
// module id = 693
// module chunks = 0